"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.ImageOwlTips = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    width: 100px;\n    height: 90px;\n    margin: auto;\n    background-repeat: no-repeat;\n    ", "\n"], ["\n    position: absolute;\n    z-index: 1;\n    width: 100px;\n    height: 90px;\n    margin: auto;\n    background-repeat: no-repeat;\n    ", "\n"])), function (_a) {
  var top = _a.top,
      left = _a.left,
      bottom = _a.bottom,
      rotate = _a.rotate;
  return "\n            top: " + (top ? top : 'auto') + ";\n            left: " + (left ? left : 'auto') + ";\n            bottom: " + (bottom ? bottom : 0) + ";\n            background-image: url(" + components_lib_1.appConfig.images.mascot + ");\n            transform: " + (rotate ? "rotate(" + rotate + ")" : 'none') + ";\n        ";
});
var templateObject_1;